module.exports = __webpack_public_path__ + "assets/img/included.bdd306e3.png";